import _ from './underscore-wrapper';
import Cookie from 'vendor/lib/js.cookie';
const SECURED_COOKIE = /^https/.test(window.location.href);
export default {
  setCookie: function (name, value, options) {
    Cookie.set(
      name,
      value,
      _.defaults(options || {}, {
        secure: SECURED_COOKIE,
        path: '/'
      })
    );
  },

  getCookie: function () {
    return Cookie.get.apply(Cookie, arguments);
  },

  removeCookie: function () {
    return Cookie.remove.apply(Cookie, arguments);
  }
};



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/util/Cookie.js